// @flow
import React, { FC, useContext, useEffect } from 'react';
import BxcNav from '../components/BxcNav';
import '../App.css';
import { Outlet, useOutletContext } from 'react-router-dom';
import { BeerXchangeProvider } from '../contexts/BeerXchangeContext';
import { LoginContext, LoginProvider } from '../contexts/LoginContext';
import { ToastContainer } from 'react-toastify';
import Footer from '../components/Footer';
interface Props {
  title: string;
}

const Root: FC<Props> = (props) => {
  const session = useOutletContext();
  const { loggedInUntappdUser, loggedInUser, untappdAccessToken, logOutUser } =
    useContext(LoginContext);

  useEffect(() => {
    document.title = props.title || 'BeerXchange';
  }, [props.title]);

  return (
    <BeerXchangeProvider
      loggedInUntappdUser={loggedInUntappdUser!}
      loggedInUser={loggedInUser!}
      untappdAccessToken={untappdAccessToken!}
      logOutUser={logOutUser!}
    >
      <div className="">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {/* Same as */}
        <ToastContainer />
        <BxcNav session={loggedInUser!} />
        <div id="detail" className="body">
          <Outlet context={session} />
        </div>
        <Footer />
      </div>
    </BeerXchangeProvider>
  );
};

export default Root;
